import "./scripts/carousel";
import "./styles/boats.scss";

function hideShowDaypartRates() {
  let availableDayparts = Array.from($('#id_available_dayparts input'))
                               .filter(input => input.checked)
                               .map(input => input.value)
  $("li.integer_field:not(.error)").each(function () {
    let input = this.querySelector('input[name*=rate]')
    if (!input || !input.name.match(/rate$/)) return
    if (this.textContent.includes("morning rate") && availableDayparts.includes('morning')
        || this.textContent.includes("afternoon rate") && availableDayparts.includes('afternoon')
        || this.textContent.includes('daily rate') && availableDayparts.includes('full-day')) {
      this.style.display = 'block'
      this.closest('.multi-field').style.display = 'block'
      this.classList.add('required')
    } else {
      this.style.display = 'none'
      this.closest('.multi-field').style.display = 'none'
    }
  })

  // Daypart selector in prices blocks
  $('select[id^="id_prices"][id*="daypart"]').each(function() {
    let optionEls = Array.from(this.querySelectorAll('option'))
    optionEls.filter(opt => opt.value).forEach(opt => {
      if (availableDayparts.includes(opt.value)) {
        opt.removeAttribute('disabled')
      } else {
        opt.setAttribute('disabled', '')
      }
    })
  })
}

window.hideShowDaypartRates = debounce(200, hideShowDaypartRates)

function hideShowStartEnd(isBaselineInput) {
  let dateFieldEls = isBaselineInput
      .closest('[id^="inline_child_prices"]')
      .querySelectorAll('.date_field')
  dateFieldEls.forEach(el => {
    if (isBaselineInput.checked) {
      el.querySelector('input').value = ''
      el.style.display = 'none'
    } else {
      el.style.display = 'block'
    }
  })
}

$(document).ready(function () {
  window.hideShowDaypartRates()
  $("#id_available_dayparts").on("change", e => {
    window.hideShowDaypartRates()
  })

  $("#id_prices-ADD").on("click", () => {setTimeout(window.hideShowDaypartRates, 200)})

  $('input[id^="id_prices"][id*="is_baseline"]').each(function() {
    hideShowStartEnd(this)
  })
  $('main').on('change', 'input[id^="id_prices"][id*="is_baseline"]', function() {
    hideShowStartEnd(this)
  })

})
